import { EventEngineEventsService } from '@amzn/event-engine-events-sdk';

import { EVENT_RUNTIME_STATE_ORDER } from '../constants';

const compareEventState = (
    stateA: EventEngineEventsService.EventStateRuntime,
    stateB: EventEngineEventsService.EventStateRuntime
) => {
    const stateAIndex = EVENT_RUNTIME_STATE_ORDER.indexOf(stateA);
    const stateBIndex = EVENT_RUNTIME_STATE_ORDER.indexOf(stateB);

    if (stateAIndex === stateBIndex) {
        return 0;
    } else if (stateAIndex > stateBIndex) {
        return 1;
    } else {
        return -1;
    }
};

export default compareEventState;
